import { UserData, UserRoles } from '../../types';

export const usersInitialState: UserData = {
  id: 0,
  email: '',
  username: '',
  favourites: null,
  disabled: null,
  role: UserRoles.GENERAL,
  lastLogin: '',
};
